module.exports = __webpack_public_path__ + "static/media/bg-01.2b5956c9.png";